module.exports = __webpack_public_path__ + "media/images/no_posts-5027df6750056b09a05945bead1cb18b.svg";